enum ConstituentType {
  PERSON = 'prs',
  ORG = 'org',
}

export default ConstituentType;
